import clsx from "clsx";
import { useCallback } from "react";
import { toast } from "react-toastify";
import { useCopyToClipboard } from "usehooks-ts";
import CopySvg from "../Svg/CopySvg";

interface CopyCardProp {
  address: string | undefined;
  isShort: boolean;
  isResponsive: boolean;
  className?: string;
  classNameIcon?: string;
}

export default function CopyCard({
  address,
  isShort,
  isResponsive,
  className,
  classNameIcon,
}: CopyCardProp) {
  const [_, copy] = useCopyToClipboard();

  const handleCopyClick = useCallback(() => {
    if (!address) {
      return;
    }

    copy(address);

    toast.success("Copied to Clipboard", {
      className:
        "!text-bitzy-glass-white !bg-bitzy-v2-black/50 !backdrop-blur !border !border-bitzy-v2-gray/100/25",
      theme: "dark",
      icon: false,
    });
  }, [copy, address]);

  return (
    <>
      <div
        onClick={handleCopyClick}
        className={clsx(
          className,
          "group cursor-pointer",
          "grid grid-cols-[auto_auto] items-center gap-2 w-full max-w-fit py-1 px-2 rounded-xl overflow-hidden",
          "border border-bitzy-v2-gray/100/25 backdrop-blur bg-bitzy-v2-white/25 inset-shadow select-none",
          "text-center text-sm md:text-md"
        )}
      >
        {isShort && (
          <>
            <div className="w-full truncate text-bitzy-glass-white group-hover:text-bitzy-glass-white/50 transition-all duration-300">
              {address?.slice(0, 6)}...
              {address?.slice(-4)}
            </div>
          </>
        )}

        {isResponsive && (
          <>
            <div className="w-full hidden md:block truncate text-bitzy-white group-hover:text-bitzy-theme transition-all duration-300">
              {address}
            </div>
            <div className="w-full block md:hidden truncate text-bitzy-white group-hover:text-bitzy-theme transition-all duration-300">
              {address?.slice(0, 6)}...
              {address?.slice(-4)}
            </div>
          </>
        )}

        <div className="text-bitzy-white flex items-center justify-center text-sm w-fit group-hover:text-bitzy-theme transition-all duration-300">
          <CopySvg className={clsx(classNameIcon)} />
        </div>
      </div>
    </>
  );
}
